import { InputHTMLAttributes, forwardRef } from 'react';
import './Form.css';

export type InputSize = 'sm' | 'md' | 'lg';

export interface InputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'size'
> {
  /** Size variant */
  size?: InputSize;
  /** Error state */
  error?: boolean;
  /** Full width input */
  fullWidth?: boolean;
}

/**
 * Input component for text entry.
 *
 * @example
 * ```tsx
 * <Input
 *   placeholder="Enter your name"
 *   value={name}
 *   onChange={(e) => setName(e.target.value)}
 * />
 * ```
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { size = 'md', error = false, fullWidth = false, className = '', ...props },
    ref
  ) => {
    const classNames = [
      'ui-input',
      `ui-input--${size}`,
      error && 'ui-input--error',
      fullWidth && 'ui-input--full-width',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return <input ref={ref} className={classNames} {...props} />;
  }
);

Input.displayName = 'Input';
